import React from "react";
import Box from "@mui/material/Box";

import { WarningBootstrapTooltip } from "./InfoIconWithTooltip";

export const NO_BATCH_ACCESS_MESSAGE =
  "You don't have access to this feature for the selected batch.";

/**
 * Wraps a feature CTA and shows a "no access" tooltip when `show` is true.
 * The child is wrapped in a span so the tooltip still appears on hover even
 * when the underlying button is disabled (disabled elements don't emit hover
 * events). When `show` is false the children render untouched.
 */
export default function NoAccessTooltip({
  show = false,
  placement = "top",
  message = NO_BATCH_ACCESS_MESSAGE,
  fullWidth = false,
  children,
  ...props
}) {
  if (!show) return children;

  return (
    <WarningBootstrapTooltip title={message} placement={placement} {...props}>
      {/*
        Wrapper so the tooltip anchors to the child even when it is disabled.
        By default it shrinks to the child (`inline-flex` + `width: fit-content`)
        so the tooltip stays centered over the button instead of being stretched
        to full width inside a (column) flex container. We deliberately avoid
        setting `alignSelf` so the wrapper inherits the parent's cross-axis
        alignment — otherwise a wrapped button in a row flex with
        `alignItems: center` (e.g. a button group) would jump out of alignment.
        Pass `fullWidth` for buttons that are meant to span their container.
      */}
      <Box
        component="span"
        sx={{
          display: fullWidth ? "flex" : "inline-flex",
          width: fullWidth ? "100%" : "fit-content",
          maxWidth: "100%",
          cursor: "not-allowed",
        }}
      >
        {children}
      </Box>
    </WarningBootstrapTooltip>
  );
}
